import { render, staticRenderFns } from "./TextDivider.vue?vue&type=template&id=f9a3f34e"
import script from "./TextDivider.vue?vue&type=script&lang=js"
export * from "./TextDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports